import { Skeleton } from "@/app/components/shadcn/skeleton";

const BottomHeaderItemsSkeleton = () => {
  return (
    <div className="relative w-full overflow-hidden py-2">
      <div className="flex gap-6 px-4">
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton key={i} className="h-5 w-20 shrink-0" />
        ))}
      </div>
    </div>
  );
};

export default BottomHeaderItemsSkeleton;